<template>
  <section id="events">
    <div class="container">
      <h2 class="text-center">Events</h2>
      <event v-if="events.length" v-for="event in events" :event="event"></event>
      <div v-else>
        <p>Check back for upcoming events!</p>
      </div>
    </div>
  </section>
</template>

<script>
import Event from './Event'

export default {
  name: 'events',
  components: {
    Event
  },
  props: ['events']
}
</script>

<style lang="scss" scoped>
section {
  padding: 80px 0;
}

h2 {
  margin-bottom: 3rem;
}

p {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Events.vue?97e62862